module.exports = __webpack_public_path__ + "static/widget-img-17-65e4aa116d74f87181513f0610ab5920.png";